// Libraries
import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import BackIcon from '../../static/images/left-arrow.png';
import SearchBar from './SearchBar';

const BinHeader = props => {
    const { userAction, data, error } = props;
    const history = useHistory();
    const { searchValue } = useParams();

    const onBack = () => {
        history.push('/manage-bin');
    };

    const errorMessage = error && error.errorMessage;

    return (
        <div className="search-bin-header">
            <div className="search-wrap">
                <div className="search-title">
                    <button
                        type="submit"
                        className="back-icon"
                        onClick={onBack}
                    >
                        <img src={BackIcon} alt="Back" />
                    </button>
                    <h3>You have searched “{searchValue}” Bin</h3>
                    <label className="search-breadCrumb">
                        Manage Bin &gt; Search
                    </label>
                </div>
                <SearchBar isReset />
            </div>
            {errorMessage ? (
                <div className="not-found">{errorMessage}</div>
            ) : (
                <ul className="search-item">
                    <li>
                        <p className="item-head">Bin Head</p>
                        <p className="item-value">{data.binHead}</p>
                    </li>
                    <li>
                        <p className="item-head">Card Type</p>
                        <p className="item-value">{data.cardType}</p>
                    </li>
                    <li>
                        <p className="item-head">Card Nature</p>
                        <p className="item-value">{data.cardNature}</p>
                    </li>
                    <li>
                        <p className="item-head">Domestic</p>
                        <p className="item-value">{data.isDomestic}</p>
                    </li>
                    <li className="issueBank">
                        <p className="item-head">Issuing Bank</p>
                        <p className="item-value">{data.issuingBank}</p>
                    </li>
                    <li>
                        <p className="item-head">EMI Bin</p>
                        <p className="item-value">{data.emiBin}</p>
                    </li>
                    <li>
                        <p className="item-head">Bin Block</p>
                        <p className="item-value">{data.binBlocked}</p>
                    </li>
                    <li>
                        <p className="item-head">Last Update</p>
                        <p className="item-value">{data.lastUpdated}</p>
                    </li>
                    <li>
                        <p className="item-head">Action</p>
                        <div className="item-action">
                            {userAction({ original: { ...data } })}
                        </div>
                    </li>
                </ul>
            )}
        </div>
    );
};

BinHeader.propTypes = {
    userAction: PropTypes.func,
    selectedTab: PropTypes.string,
    setSelectedTab: PropTypes.func,
    data: PropTypes.object,
    error: PropTypes.object,
};

export default BinHeader;
